<template>
  <div class="values-master-detail">
    <ValuesTexture class="values-texture" />
    <master-detail :items="$options.valueItems" />
  </div>
</template>

<script>
import MasterDetail from '@/components/master-detail/MasterDetail';
import ValuesTexture from '@/assets/texture-about-values.svg';

const valueItems = [
  {
    id: 'integrity',
    title: 'Integrity',
    subtext: 'Do the right thing, always.',
    file: 'animations/integrity.lottie'
  },
  {
    id: 'diversity',
    title: 'Diversity',
    subtext: 'Intentionally commit to the equitable respect, inclusion, and empowerment of all individuals.',
    file: 'animations/diversity.lottie'
  },
  {
    id: 'responsiveness',
    title: 'Responsiveness',
    subtext: 'Act promptly and decisively, anchored by deep knowledge and careful listening.',
    file: 'animations/responsiveness.lottie'
  },
  {
    id: 'collaboration',
    title: 'Collaboration',
    subtext: 'Work enthusiastically with others and be open to different perspectives.',
    file: 'animations/collaboration.lottie'
  },
  {
    id: 'service',
    title: 'Service',
    subtext: 'Commit to helping our policyholders, team members, and community.',
    file: 'animations/service.lottie'
  },
  {
    id: 'innovation',
    title: 'Innovation',
    subtext: 'Continually seek better solutions while anticipating future needs.',
    file: 'animations/innovation.lottie'
  },
  {
    id: 'stewardship',
    title: 'Stewardship',
    subtext: 'Take good care of the resources entrusted to us.',
    file: 'animations/stewardship.lottie'
  }
];

export default {
  name: 'ValuesMasterDetail',
  components: {
    MasterDetail,
    ValuesTexture,
  },
  valueItems
};
</script>
